<template>
    <div
        class="ResultPrimer"
        :class="{ 'ResultPrimer--mobile': isMobile, 'ResultPrimer--desktop': !isMobile }">
        <template v-if="isMobile">
            <carousel
                :per-page="1"
                navigation-enabled
                loop>
                <slide>
                    <p
                        class="ResultPrimer-copy"
                        v-html="translation.calculate.result.primerAltSilicSealSilic"/>

                    <img
                        src="/images/silic_seal.png"
                        alt="Primer"

                        class="ResultPrimer-image">
                    <div class="ResultPrimer-content">

                        <strong class="ResultPrimer-title">Hempel’s Conversion Primer 45441</strong>
                        <span class="ResultPrimer-amount">
                            {{ roundUpQuarter(isUs ? litersToGallons(volumeSeal) : volumeSeal) }}
                            {{ volumeMeasurementUnitLabelBig }}
                        </span>

                        <div class="ResultPrimer-suggestion">
                            <small>{{ translation.calculate.result.suggestedAmount }}</small>
                            <hempel-combination
                                :quantity="biggerSealCans"
                                :size="volumeMeasurementUnitBig"
                                icon="antifoulingBucket"
                                :coats=1
                                class="ResultPrimer-combination"
                                v-if="biggerSealCans > 0"/>
                        </div>

                    </div>
                </slide>
                <slide>
                    <div class="ResultPrimer-copy">
                        <p v-html="translation.calculate.result.primerAlLightSilic"/>

                        <p>For more detailed info follow this <a
                            target="_blank"
                            title="Silic One"
                            :href="'https://www.hempelyacht.com/'+ this.$route.query.paintLocation + '/products/biocide-free/silic-one/case-1'">link</a>.</p>
                    </div>

                    <img
                        src="/images/silic_lightprimer.jpeg"
                        alt="Primer"

                        class="ResultPrimer-image">
                    <div class="ResultPrimer-content">

                        <strong class="ResultPrimer-title">Hempel’s Light Primer 45551</strong>
                        <span class="ResultPrimer-amount">
                            {{ roundUpQuarter(isUs ? litersToGallons(volumeLightPrimer) : volumeLightPrimer) * 5 }}
                            {{ volumeMeasurementUnitLabelBig }}
                        </span>

                        <div class="ResultPrimer-suggestion">
                            <small>{{ translation.calculate.result.suggestedAmount }} {{ translation.calculate.result.fiveCoats }}</small>
                            <hempel-combination
                                :quantity="biggerLightPrimerCans"
                                :size="volumeMeasurementUnitBig"
                                icon="antifoulingBucket"
                                :coats=5
                                class="ResultPrimer-combination"
                                v-if="biggerLightPrimerCans > 0"/>
                        </div>

                    </div>
                </slide>
                <slide>
                    <p
                        class="ResultPrimer-copy"
                        v-html="translation.calculate.result.primerAltTiecoatSilic"/>

                    <img
                        src="/images/silic_tiecoat.png"
                        alt="Primer"

                        class="ResultPrimer-image">
                    <div class="ResultPrimer-content">

                        <strong class="ResultPrimer-title">Hempel's Silic One Tiecoat 27450</strong>
                        <span class="ResultPrimer-amount">
                            {{ roundUpQuarter(isUs ? litersToGallons(volumeTiecoat) : volumeTiecoat) }}
                            {{ volumeMeasurementUnitLabelBig }}
                        </span>

                        <div class="ResultPrimer-suggestion">
                            <small>{{ translation.calculate.result.suggestedAmount }}</small>
                            <hempel-combination
                                :quantity="biggerTiecoatCans"
                                :size="volumeMeasurementUnitBig"
                                icon="antifoulingBucket"
                                class="ResultPrimer-combination"
                                v-if="biggerTiecoatCans > 0"/>
                        </div>

                    </div>
                </slide>
            </carousel>

        </template>
        <template v-else>

            <carousel
                :per-page="1"
                navigation-enabled
                loop>
                <slide>
                    <p
                        class="ResultPrimer-copy"
                        v-html="translation.calculate.result.primerAltSilicSealSilic"/>

                    <strong class="ResultPrimer-title">Hempel’s Conversion Primer 45441</strong>

                    <div class="ResultPrimer-content">
                        <img
                            src="/images/hempels-conversion-primer.png"
                            alt="Primer"
                            class="ResultPrimer-image">

                        <div class="ResultPrimer-suggestion">
                            <span class="ResultPrimer-amount">
                                {{ roundUpQuarter(isUs ? litersToGallons(volumeSeal) : volumeSeal) }}
                                {{ volumeMeasurementUnitLabelBig }}
                            </span>

                            <small>{{ translation.calculate.result.suggestedAmount }}</small>
                            <div class="hempel-combination-big">
                                <hempel-combination
                                    :quantity="biggerSealCans"
                                    :size="volumeMeasurementUnitBig"
                                    icon="antifoulingBucket"
                                    :coats=1
                                    class="ResultPrimer-combination"
                                    v-if="biggerSealCans > 0"/>
                            </div>
                        </div>
                    </div>
                </slide>
                <slide>
                    <div class="ResultPrimer-copy">
                        <p v-html="translation.calculate.result.primerAlLightSilic"/>

                        <p>For more detailed info follow this <a
                            target="_blank"
                            title="Silic One"
                            :href="'https://www.hempelyacht.com/'+ this.$route.query.paintLocation + '/products/biocide-free/silic-one/case-1'">link</a>.</p>
                    </div>

                    <strong class="ResultPrimer-title">Hempel’s Light Primer 45551</strong>

                    <div class="ResultPrimer-content">
                        <img
                            src="/images/silic_lightprimer.jpeg"
                            alt="Primer"
                            class="ResultPrimer-image">

                        <div class="ResultPrimer-suggestion">
                            <span class="ResultPrimer-amount">
                                {{ roundUpQuarter(isUs ? litersToGallons(volumeLightPrimer) : volumeLightPrimer) * 5 }}
                                {{ volumeMeasurementUnitLabelBig }}
                            </span>
                            <small>{{ translation.calculate.result.suggestedAmount }} {{ translation.calculate.result.fiveCoats }}</small>
                            <div class="hempel-combination-big">
                                <hempel-combination
                                    :quantity="biggerLightPrimerCans"
                                    :size="volumeMeasurementUnitBig"
                                    icon="antifoulingBucket"
                                    :coats=5
                                    class="ResultPrimer-combination"
                                    v-if="biggerLightPrimerCans > 0"/>
                            </div>
                        </div>
                    </div>
                </slide>
                <slide>
                    <p
                        class="ResultPrimer-copy"
                        v-html="translation.calculate.result.primerAltTiecoatSilic"/>

                    <strong class="ResultPrimer-title">Hempel's Silic One Tiecoat 27450</strong>

                    <div class="ResultPrimer-content">
                        <img
                            src="/images/silic_tiecoat.png"
                            alt="Primer"
                            class="ResultPrimer-image">

                        <div class="ResultPrimer-suggestion">
                            <span class="ResultPrimer-amount">
                                {{ roundUpQuarter(isUs ? litersToGallons(volumeTiecoat) : volumeTiecoat) }}
                                {{ volumeMeasurementUnitLabelBig }}
                            </span>

                            <small>{{ translation.calculate.result.suggestedAmount }}</small>
                            <div class="hempel-combination-big">
                                <hempel-combination
                                    :quantity="biggerTiecoatCans"
                                    :size="volumeMeasurementUnitBig"
                                    icon="antifoulingBucket"
                                    class="ResultPrimer-combination"
                                    v-if="biggerTiecoatCans > 0"/>
                            </div>
                        </div>
                    </div>
                </slide>
            </carousel>

        </template>
    </div>

</template>
<script>
import HempelCombination from '@/components/shared/combination/Combination'
import { Carousel, Slide } from 'vue-carousel'

export default {
    components: {
        HempelCombination,
        Carousel,
        Slide
    },
    props: {
        volume: {
            type: Number,
            required: true
        },
        small: {
            type: Number,
            required: true
        }
    },
    computed: {
        isUs() {
            return (
                this.$route.query.paintLocation === 'en-US' ||
                this.$route.query.paintLocation === 'en-CA'
            )
        },
        volumeMeasurementUnitSmall() {
            return this.$route.query.paintLocation === 'en-US' ||
                this.$route.query.paintLocation === 'en-CA'
                ? '0.25gal'
                : '750ml'
        },
        volumeMeasurementUnitBig() {
            return this.$route.query.paintLocation === 'en-US' ||
                this.$route.query.paintLocation === 'en-CA'
                ? '0.5gal'
                : '2.25L'
        },
        volumeMeasurementUnitLabelBig() {
            return this.$route.query.paintLocation === 'en-US' ||
                this.$route.query.paintLocation === 'en-CA'
                ? 'gal'
                : 'L'
        },
        volumeSeal() {
            return this.calculateVolume(15)
        },
        volumeTiecoat() {
            return this.calculateVolume(10)
        },
        volumeLightPrimer() {
            const vol = this.calculateVolume(8.2)
            const rounded = this.roundUpQuarter(vol)
            return rounded < 2.5 ? 2.5 : rounded
        },
        biggerSealCans() {
            return this.$route.query.paintLocation === 'en-US' ||
                this.$route.query.paintLocation === 'en-CA'
                ? Math.ceil(this.volumeSeal * 0.264172 / 0.5)
                : Math.ceil(this.volumeSeal / 2.25)
        },
        sealCans() {
            // eslint-disable-next-line no-nested-ternary
            return this.$route.query.paintLocation === 'en-US' ||
                this.$route.query.paintLocation === 'en-CA'
                ? this.biggerSealCans * 0.5 > this.litersToGallons(this.volumeSeal) ? null : 1
                : Math.ceil((this.volumeSeal - this.biggerSealCans * 2.25) / 0.75)
        },
        // tiecoatCans() {
        //     return this.$route.query.paintLocation === 'en-US'
        //         ? Math.ceil(this.volumeTiecoat * 0.264172 / 0.25)
        //         : Math.ceil(this.volumeTiecoat / 0.75)
        // },
        biggerTiecoatCans() {
            return this.$route.query.paintLocation === 'en-US' ||
                this.$route.query.paintLocation === 'en-CA'
                ? Math.ceil(this.volumeTiecoat * 0.264172 / 0.5)
                : Math.ceil(this.volumeTiecoat / 2.25)
        },
        tiecoatCans() {
            // eslint-disable-next-line no-nested-ternary
            return this.$route.query.paintLocation === 'en-US' ||
                this.$route.query.paintLocation === 'en-CA'
                ? this.biggerTiecoatCans * 0.5 > this.litersToGallons(this.volumeTiecoat) ? null : 1
                : Math.ceil(
                      (this.roundUp(this.volumeTiecoat) - this.biggerTiecoatCans * 2.25) / 0.75
                  )
        },
        // lightPrimerCans() {
        //     return this.$route.query.paintLocation === 'en-US'
        //         ? Math.ceil(this.volumeLightPrimer * 0.264172 / 0.25)
        //         : Math.ceil(this.volumeLightPrimer / 0.75)
        // }
        biggerLightPrimerCans() {
            return this.$route.query.paintLocation === 'en-US' ||
                this.$route.query.paintLocation === 'en-CA'
                ? this.volumeLightPrimer * 0.264172 / 0.5
                : this.volumeLightPrimer / 2.25
        },
        lightPrimerCans() {
            // eslint-disable-next-line no-nested-ternary
            return this.$route.query.paintLocation === 'en-US' ||
                this.$route.query.paintLocation === 'en-CA'
                ? this.biggerLightPrimerCans * 0.5 > this.litersToGallons(this.volumeLightPrimer)
                    ? null
                    : 1
                : Math.ceil((this.volumeLightPrimer - this.biggerLightPrimerCans * 2.25) / 0.75)
        }
    },
    methods: {
        roundUp(number) {
            return Math.ceil(number * 2) / 2
        },
        roundUpQuarter(number) {
            return Math.ceil(4 * number) / 4
        },
        litersToGallons(liter) {
            return (liter / 3.785).toFixed(2)
        },
        milliliterToQuarts(milliliter) {
            return milliliter * (0.00105669).toFixed(2)
        },
        calculateVolume(cov) {
            if (!this.getSelectedProduct || !this.getSelectedProduct.coverage) {
                return 0
            }

            const boatType = this.$route.query.type
            const keel = this.$route.query.keelType || null
            const { dimensions } = this.$route.query
            const unit = dimensions.split('-')[0]

            let volume
            if (
                !dimensions.split('-')[1] &&
                !dimensions.split('-')[2] &&
                !dimensions.split('-')[3] &&
                dimensions.split('-')[4]
            ) {
                volume = dimensions.split('-')[4] / cov
            } else {
                const low =
                    unit === 'm'
                        ? parseFloat((dimensions.split('-')[1] * 1).toFixed(2))
                        : parseFloat((dimensions.split('-')[1] * 0.3048).toFixed(2))
                const beam =
                    unit === 'm'
                        ? parseFloat((dimensions.split('-')[2] * 1).toFixed(2))
                        : parseFloat((dimensions.split('-')[2] * 0.3048).toFixed(2))
                const draft =
                    unit === 'm'
                        ? parseFloat((dimensions.split('-')[3] * 1).toFixed(2))
                        : parseFloat((dimensions.split('-')[3] * 0.3048).toFixed(2))

                if (boatType !== 'sailing') {
                    volume = low * (beam + draft) * 0.85 / cov
                } else
                    volume =
                        keel === 'fin'
                            ? low * (beam + draft) * 0.5 / cov
                            : low * (beam + draft) * 0.75 / cov
            }
            return volume
        }
    }
}
</script>
